module.exports = __webpack_public_path__ + "static/media/recommendedf.45191083.png";